/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Settings from '../components/Settings';
import house from '../assets/icons/house-door.svg';
import pfeil from '../assets/icons/Pfeil.svg';

import step1 from '../assets/images/overview/step-1-grafik.svg';
import step2 from '../assets/images/overview/step-2-grafik-01.svg';
import step3 from '../assets/images/overview/step-3-grafik.png';
import step4 from '../assets/images/overview/step-4-grafik.png';

import img1 from '../assets/images/details/frau-info-grafik.png';
import img2 from '../assets/images/details/frau-produktegrafik.png';
import img3 from '../assets/images/details/AdobeStock_75313743.jpg';

const Homepage = () => {
  return (
    <div id='details'>
      {/* HEAD */}
      <Navbar />
      {/* sub nav  */}
      <div
        id='sub-nav'
        className='container-xxl d-none d-md-block mb-3 mt-4'
        style={{ fontSize: 12 }}>
        <div className='d-flex align-content-center' style={{ gap: '0.5rem' }}>
          <a href='#'>
            {' '}
            <img src={house} alt='' style={{ width: 14 }} />
          </a>
          <span>»</span>
          <a href='#'>Ratgeber</a>
          <span>»</span>
          <a href='#'>Pflegehilfsmittel gratis erhalten</a>
        </div>
      </div>
      {/* HERO  */}
      <section className='container-xxl px-0 px-xxl-0' id='hero-details'>
        <div className='banner'>
          <div>
            <h1 className='mb-2'>Pflegehilfsmittel</h1>
            <h1>
              <span>gratis</span> erhalten
            </h1>
          </div>
          <div>
            <button className='btn-primary'>Jetzt Ihr kostenloses PflegehilfeSet anfordern</button>
          </div>
        </div>
      </section>
      {/* wissenswertes details */}
      <section className='container px-3 px-lg-3 px-xxl-0 py-5' id='wissenswertes-details'>
        <div className='row gx-3 gy-5'>
          <div className='col-12 col-xl-6'>
            <div>
              <h3>Pflegehilfsmittel als monatliche Gratisleistung</h3>
              <p className='py-4'>
                Pflege ist teuer, das weiß auch jeder Pflegebedürftige, der zuhause betreut wird.
                Häufig sind es gerade die Kleinigkeiten, welche zur täglichen Pflege benötigt
                werden, die ins Geld gehen. Zahlreiche Utensilien, wie beispielsweise
                Bettschutzeinlagen, Einmalhandschuhe und Desinfektionsmittel werden nach einmaliger
                Verwendung entsorgt, der Bestand muss also jeden Tag aufgefrischt werden. Da wird es
                Sie freuen, dass wir Ihnen solche Pflegehilfsmittel gratis zur Verfügung stellen
                können. Und zwar ganz unbürokratisch. Ihnen entstehen dafür weder Kosten noch
                Arbeitsaufwand.
              </p>
              <a href='#' className='pfeil'>
                Zum Konfigurator
                <span>
                  <img src={pfeil} alt='' />
                </span>
              </a>
            </div>
          </div>
          <div className='col-12 col-xl-6 d-flex flex-column flex-md-row'>
            <div>
              <img src={img1} alt='' className='details-img' />
            </div>
            <div className='mt-4'>
              <h3 className='mb-4'>
                Pflegehilfsmittel im <span>Wert von 40 €</span>* pro Monat gratis
              </h3>
              <p>
                Bestellen Sie Ihre <b>monatlichen Pflegehilfsmittel kostenfrei</b> mit dem
                PflegehilfeSet. Die Pflegekasse übernimmt die Kosten, wir übernehmen für Sie die
                Abrechnung. * Der in § 40 SGB XI geregelte Höchstbetrag für zum Verbrauch bestimmter
                Pflegehilfsmittel, der von Pflegekassen übernommen wird, wurde vom
                Bundesministeriums für Gesundheit ab 01.01.2022 wieder auf 40 € pro Monat herunter
                gesetzt.
              </p>
            </div>
          </div>
          <div className='col-12 col-xl-6'>
            <div className='d-flex flex-column flex-md-row'>
              <div>
                <img src={img2} alt='' className='details-img' />
              </div>
              <div className='mt-4'>
                <h3>Auswahl</h3>
                <p className='mb-4 mt-2'>
                  Wählen Sie die benötigten Produkte aus und konfigurieren Sie Ihr individuelles Set
                  im Wert von 40 €. Wir stehen Ihnen auf allen Kommunikationswegen für die
                  Bestellung zur Verfügung. Mehr zu den Produkten
                </p>
                <a href='#' className='pfeil'>
                  Mehr zu den Produkten
                  <span>
                    <img src={pfeil} alt='' />
                  </span>
                </a>
              </div>
            </div>
            <div className='d-grid justify-content-center my-3'>
              <button className='btn-primary'>Zum Konfigurator</button>
            </div>
          </div>
          <div className='col=12 col-xl-6'>
            <div>
              <img src={img3} alt='' style={{ width: '100%' }} />
            </div>
            <div className='mt-4'>
              <h3>Monatliche Pflegesachleistungen von der Pflegekasse</h3>
              <p className='my-3 my-xxl-4'>
                Jeden Monat stehen jedem Pflegebedürftigen mit Pflegegrad, der in den eigenen vier
                Wänden betreut wird, von seiner Pflegekasse Sachleistungen in Höhe von 40 Euro
                brutto zu. Voraussetzung für diese Leistungen ist die Pflege durch eine
                Privatperson, und zwar auch dann, wenn der Pflegende durch einen Pflegedienst
                unterstützt wird.
              </p>
              <p>
                Wir sorgen dafür, dass Sie als pflegender Angehöriger für die ambulante Pflege
                erhalten, was Ihnen zusteht, indem wir sowohl die Beantragung als auch die
                Abrechnung der Sachleistungen für Sie übernehmen. Was in Ihrem individuellen
                PflegehilfeSet enthalten sein soll, bestimmen Sie selbst. Wir stellen Ihnen ein
                umfassendes Sortiment an Einmalhandschuhen, Fingerlingen, Hände- und
                Flächendesinfektionsmitteln, Bettschutzeinlagen, Schutzschürzen und Mundschutz zur
                Verfügung, aus dem Sie sich Ihre persönliche Pflegebox bis zu einem Wert von 40,00 €
                brutto zusammenstellen. Die ausgewählten Pflegehilfsmittel kommen gratis zu Ihnen
                ins Haus, Monat für Monat. Dafür müssen Sie sich nicht vertraglich an uns binden,
                diesen Service können Sie jederzeit wieder abbestellen.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* pflegen */}
      <section id='pflegen' className='py-5' style={{ position: 'relative' }}>
        <div className='container-xxl px-0'>
          <div className='container-xxl px-3 px-xl-5 px-xxl-0'>
            <div className='my-5 title'>
              <h2>
                Sie pflegen einen Angehörigen zu Hause oder sind selbst pflegebedürftig? Sichern Sie
                sich das PflegehilfeSet im Wert von 40,- Euro?!
              </h2>
              <p className='my-2'>So bekommen Sie Ihr kostenfreies PflegehilfeSet nach Hause.</p>
            </div>
            <div>
              <div className='row gy-5 gx-2 px-3 px-lg-0'>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step1} alt='step1' />
                  </div>
                  <div>
                    <h3>Bestellung</h3>
                    <p>
                      Wählen Sie die benötigten Produkte aus und konfigurieren Sie Ihr individuelles
                      Set im Wert von 40 €. Wir stehen Ihnen auf allen Kommunikationswegen für die
                      Bestellung zur Verfügung.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step2} alt='step2' style={{ height: '100%' }} />
                  </div>
                  <div>
                    <h3>Lieferung</h3>
                    <p>
                      In der Regel erhalten Sie Ihre Bestellung kürzester Zeit direkt nach Hause
                      bzw. zum gewünschten Einsatzort.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step3} alt='step3' />
                  </div>
                  <div>
                    <h3>Beantragung</h3>
                    <p>
                      Schon nach Abschluss Ihrer Bestellung leiten wir für Sie die Beantragung und
                      Abrechnung bei der Pflegekasse ein. Sie brauchen sich um nichts kümmern.
                    </p>
                  </div>
                </div>
                <div className='col-12 col-md-6 col-xl-3 d-flex flex-column'>
                  <div>
                    <img src={step4} alt='step4' />
                  </div>
                  <div>
                    <h3>Abwicklung</h3>
                    <p>
                      Sie erhalten monatlich Ihr PflegehilfeSet, das Sie bequem an Ihre Bedürfnisse
                      anpassen können. Es gibt keine versteckten Kosten und keine Vertragsbindung -
                      nur volle Flexibilität für Sie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='article-btn'>
              <button className='btn-primary mt-5'>Zum Konfigurator</button>
            </div>
          </div>
        </div>
      </section>
      {/* Newsletter */}
      <section id='newsletter'>
        <div className='title px-2'>
          <h2 className=''>Newsletter</h2>
          <p>Abonnieren Sie den kostenlosten Newsletter!</p>
        </div>
        <div className='newsletter-input'>
          <input type='email' name='email' placeholder='E-Mail-Adresse eingeben…' id='email' />
          <button className=''>Abonnieren</button>
        </div>
      </section>
      {/* Footer */}
      <Footer />
      {/* setting */}
      <Settings />
    </div>
  );
};

export default Homepage;
